import React, { Suspense, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { useAppSelector } from 'app/store'

import { userDataActionCreators } from 'app/store/actions/user-data.actions'
import { enableWithCredentialsForEpub } from 'app/services/core/config.service'

import useMobileVh from 'app/hooks/use-mobile-vh.hook'
import useCorrectGrade from 'app/hooks/use-correct-grade.hook'
import useDdRum from 'app/hooks/use-dd-rum.hook'
import AppModeContextProvider from 'app/contexts/app-mode/app-mode.context'
import RobotSpinner from 'app/components/spinner/robot-spinner.component'
import AppWithRouter from 'app/app'
import NoLicensePage from 'app/pages/errors/noLicense.page'
import { initDictionary } from 'app/services/localization/localization.service'
import { fetchEnvironmentFlags } from 'app/services/api/amp-config-service'

import 'app/styles/normalize.scss'
import 'app/styles/main.scss'

const Root = () => {
  const { loading, error } = useAppSelector((state) => state.userData)
  const dispatch = useDispatch()

  useCorrectGrade()
  useMobileVh()
  useDdRum()
  initDictionary()

  useEffect(() => {
    dispatch(userDataActionCreators.getUserData.request())
    enableWithCredentialsForEpub()
    fetchEnvironmentFlags()
  }, [dispatch])

  if (loading) return <RobotSpinner />
  if (error) return <NoLicensePage />

  return (
    <Suspense fallback={<RobotSpinner />}>
      <AppModeContextProvider>
        <AppWithRouter />
      </AppModeContextProvider>
    </Suspense>
  )
}

export default Root
